<template>
  <div class="prospetto-ferie" v-loading="loading" :style="{ height: (ifNote ? '355' : '320')+ 'px'}">
    <el-carousel arrow="never" :autoplay="false" indicator-position="outside" trigger="click" :style="{ height: (ifNote ? '355' : '320')+ 'px'}">
      <el-carousel-item :style="{ height: (ifNote ? '320' : '288')+ 'px'}" v-if="cards_pag1.length > 0">
        <div class="note" v-if="ifNote"><span>{{ getLabel(note_pag1) }}</span></div>
        <div class="card-ferie" v-for="(item, index) in cards_pag1" :key="index">
          <div class="scheda">
            <div class="scheda-label truncate">
              {{ getLabel(item.des) }}
            </div>
            <div class="scheda-valore" :style="{ color: item.color }">
              {{ item.valore }}
            </div>
            <div class="scheda-tipo">
              {{  item.tipo.trim() === '' ? '' : $t('dashboard.' + item.tipo) }}
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item :style="{ height: (ifNote ? '320' : '288')+ 'px'}" v-if="cards_pag2.length > 0">
        <div class="note" v-if="ifNote"><span>{{ getLabel(note_pag2) }}</span></div>
        <div class="card-ferie" v-for="(item, index) in cards_pag2" :key="index">
          <div class="scheda">
            <div class="scheda-label truncate">
              {{ getLabel(item.des) }}
            </div>
            <div class="scheda-valore" :style="{ color: item.color }">
              {{ item.valore }}
            </div>
            <div class="scheda-tipo">
              {{  item.tipo.trim() === '' ? '' : $t('dashboard.' + item.tipo) }}
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    props: {
      codLang: {
        type: String
      }
    },
    name: 'ProspettoAssenze',
    i18n: {},
    data () {
      return {
        loading: false,
        loading: false,
        cards_assenze: [],
        cards_pag1: [],
        cards_pag2: [],
        note_pag1: {},
        note_pag2: {},
        periodoDal: '',
        periodoAl: '',
        country: 0,
        ifNote: false
      }
    },
    mounted: function () {
      this.initialize()
    },
    activated: function () {
      this.initialize()
    },
    deactivated: function () {
    },
    methods: {
      initialize: function () {
        this.codLang = sessionStorage.getItem('codLang')
        this.country = this.$store.state.country
        this.ifNote = this.country === '5' || this.country === '3' ? true : false
        this.getRiepilogoFerie()
      },
      getRiepilogoFerie: function () {
        this.loading = true
        this.$http.get('dashboard/' + this.country + '/assenze', {
          params: {
            codLang: sessionStorage.getItem('codLang')
          }
        })
          .then(response => {
            if (response.body.rc === 0 && response.body.hasOwnProperty('data')) {

              // TAB 1
              this.$set(this, 'cards_pag1', [])
              this.$set(this, 'note_pag1', response.body.data.note1 ? response.body.data.note1 : {})
              let pag1 = response.body.data.pag1
              if (pag1) {
                for (let assenza of pag1) {
                  //let value = (isNaN(parseFloat((assenza.valore).replace(',', '.'))) ? '' : parseFloat((assenza.valore).replace(',', '.')))
                  this.cards_pag1.push({
                    tipo: assenza.tipo.toLowerCase(),
                    des: assenza.label,
                    color: '#48adb5',
                    valore: assenza.contatore == '' ? '' : parseFloat(assenza.valore).toFixed(2),
                    show: true
                  })
                }
              }
              // TAB 2
              this.$set(this, 'cards_pag2', [])
              this.$set(this, 'note_pag2', response.body.data.note2 ? response.body.data.note2 : {})
              let pag2 = response.body.data.pag2
              if (pag2) {
                for (let assenza of pag2) {
                  // let value = (isNaN(parseFloat((assenza.valore).replace(',', '.'))) ? '' : parseFloat((assenza.valore).replace(',', '.')))
                  this.cards_pag2.push({
                    tipo: assenza.tipo.toLowerCase(),
                    des: assenza.label,
                    color: '#48adb5',
                    valore: assenza.contatore == '' ? '' : parseFloat(assenza.valore).toFixed(2),
                    show: true
                  })
                }
              }
            }
            else {
              this.$set(this, 'cards_pag1', [])
              this.$set(this, 'note_pag1', {})
              this.$set(this, 'cards_pag2', [])
              this.$set(this, 'note_pag2', {})
            }
            this.loading = false
          })
      },
      getLabel: function (label) {
        if (label === undefined || label === null) {
          return 'ER:'+label
        } else {
          return label[this.codLang]
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .prospetto-ferie {
    background-color: #e7e7e7;
    border-radius: 5px;
    border: 1px solid @greyLine;
    padding: 8px 5px;
    
    .note {
      overflow: hidden;
      text-overflow: ellipsis;
      height: 40px;
      line-height: 20px;
      .set-font(@size: 13px; @color: @greenRiva);
			letter-spacing: 0.5px;
			//margin-top: 5px;
			//margin-bottom: 5px;
    }
    .el-carousel__container {
      height: calc(100% - 32px);
      .card-ferie {
        height: 90px; //110px;
        width: 50%;
        // display: inline-block;
        float: left;
        margin-bottom: 6px;
        .scheda {
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          background-color: #ffffff;
          background: #fff;
          // -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          // -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          // box-shadow: 0px 0px 13px 1px #e7e7e7;
          width: 96%;
          margin: auto;
          height: 90px; //110px;
          text-align: center;
          .scheda-label {
            margin-top: 8px;
            text-transform: uppercase;
            height: 16px;
            line-height: 16px;
            .set-font(@size: 14px; @color: #bd3090);
          }
          .scheda-valore {
            margin-top: 6px;
            .set-font(@size: 33px; @color: #48adb5);
            line-height: 24px;
          }
          .scheda-tipo {
            margin-top: 10px;
            text-transform: uppercase;
            .set-font(@size: 12px; @color: #3f2a6d);
          }
        }
      }
      .didascalia {
        .set-font(@size: 14px; @color: @grayTesto);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage/ProspettoAssenze.vue